import Skeleton from '@mui/material/Skeleton';

import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../hooks/useGraphQLQuery.hook';

export const User_OneUserName_QueryDocument = graphql(`
  query User_OneUserName_Query($id: Id!) {
    findPersonOfUser(userId: $id) {
      fullName
    }
  }
`);

interface Props {
  readonly id: Id;
}

export const UserName = ({ id }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    User_OneUserName_QueryDocument,
    { id },
    { enabled: !!id },
  );

  if (isSuccess) {
    return data.findPersonOfUser.fullName;
  }

  return (
    <Skeleton sx={{ display: 'inline-block' }} variant="text" width={210} />
  );
};
